import { createSlice } from '@reduxjs/toolkit';
import { emptyFormState } from '../emptyState';
import { fetchStatus } from '../status';
import { getReportData } from '../../api/network';


// Then, handle actions in your reducers:
const reportDataSlice = createSlice({
  name: 'reportData',
  emptyFormState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    reportDataFetchStart: (state) => {
      state.status = fetchStatus.FETCH_START;
      state.fetching = true;
    },
    reportDataFetchSuccess: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
    },
    reportDataFetchFail: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
  },
});

export const { reportDataFetchStart, reportDataFetchSuccess, reportDataFetchFail } = reportDataSlice.actions;

export const reportDataReducer = reportDataSlice.reducer;

export const fetchReportData = (reportUid) => (dispatch, getState) => {
  const items = getState();

  if (items.network.reportData.status === fetchStatus.FETCH_START) {
    return;
  }

  dispatch(reportDataFetchStart());

  getReportData(reportUid)
    .then((payload) => {
      dispatch(reportDataFetchSuccess(payload.data));
    })
    .catch((error) => {
      dispatch(reportDataFetchFail(error));
    });
};

export const setReportDataToNull = () => (dispatch, getState) => {
  const items = getState();

  if (items.network.reportData.status === fetchStatus.FETCH_START) {
    return;
  }
  dispatch(reportDataFetchSuccess({}));
};

